(function(){
'use strict';

scPageAccessService.$inject = ["scMembersService", "scCampaignsService", "scAuthorizeService", "PERMISSIONS"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @kind service
 * @name scPageAccessService
 *
 * @description
 * Stores an boolean which decides if the user has access to the current fundraiser/team page or not.
 * It first determines if the current member id matches the creator's id
 * then checks Cerberus for permission to update fundraising pages or team pages.
 */

function scPageAccessService(scMembersService, scCampaignsService, scAuthorizeService, PERMISSIONS) {
  this.pageAccess = false;
  this.campaignId = '';
  this.memberId = '';

  this.setPageAccess = function (access) {
    this.pageAccess = access;
  };

  this.getPageType = function (pageType) {
    if (pageType) {
      return pageType;
    }

    if (_.get(SC, 'team')) {
      return 'team';
    } else if (_.get(SC, 'fundraiser')) {
      return 'fundraiser';
    }

    return null;
  };

  this.checkPageAdminAccess = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pageType) {
      var type, permissions, authorized, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = this.getPageType(pageType);

              if (type) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', this.setPageAccess(false));

            case 3:
              permissions = type === 'team' ? PERMISSIONS.fundraising_team.update : PERMISSIONS.fundraising_page.update;
              _context.next = 6;
              return scAuthorizeService.isAuthorized(permissions);

            case 6:
              authorized = _context.sent;
              result = authorized.every(function (perm) {
                return perm.result;
              });


              this.setPageAccess(result);

              return _context.abrupt('return', result);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.sync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var campaignId, memberId, result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            campaignId = _.get(scCampaignsService, 'active.current.id', false);
            memberId = _.get(scMembersService, 'you.current.id', false);
            result = false;

            // only check access level if the campaign or member changed

            if (!(this.campaignId != campaignId || this.memberId != memberId)) {
              _context2.next = 7;
              break;
            }

            _context2.next = 6;
            return this.checkPageAdminAccess();

          case 6:
            result = _context2.sent;

          case 7:

            this.setPageAccess(result);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
}

angular.module('classy').service('scPageAccessService', scPageAccessService);
})();